import React, { useCallback, useEffect, useState } from "react";
import { GoogleMap, useJsApiLoader, Marker } from "@react-google-maps/api";

const containerStyle = {
    width: "100%",
    height: "350px",
};

// AddressInput's autocomplete reuses this script when the map loads first, so it must include places.
// Kept outside the component so the loader doesn't see a new array on every render.
const MAP_LIBRARIES = ["places"];

// Calgary, used until the event has valid coordinates
const DEFAULT_CENTER = { lat: 51.0447, lng: -114.0719 };

const isValidCoord = (lat, lng) =>
    lat !== "" && lat !== null && lng !== "" && lng !== null &&
    Number.isFinite(Number(lat)) && Number.isFinite(Number(lng));

const GoogleMaps = ({ lat, lng, setLatLng }) => {
    const { isLoaded } = useJsApiLoader({
        id: "google-map-script",
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API,
        libraries: MAP_LIBRARIES,
    });

    const [map, setMap] = useState(null);
    const [marker, setMarker] = useState({});
    const [coordinates, setCoordinates] = useState({
        lat: null,
        lng: null,
    });

    const handleMapClick = (event) => {
        setMarker(() => ({
            lat: event.latLng.lat(),
            lng: event.latLng.lng(),
        }));

        setLatLng({
            lat: event.latLng.lat(),
            lng: event.latLng.lng(),
        });
    };

    const onLoad = useCallback(function callback(map) {
        // Events saved without coordinates give a non-numeric lat/lng, which Google Maps rejects
        if (isValidCoord(lat, lng)) {
            const bounds = new window.google.maps.LatLngBounds({
                lat: Number(lat),
                lng: Number(lng),
            });
            map.fitBounds(bounds);
        }

        setMap(map);
    }, []);

    const onUnmount = useCallback(function callback(map) {
        setMap(null);
    }, []);

    useEffect(() => {
        setCoordinates({
            lat,
            lng,
        });
        setMarker({
            lat,
            lng,
        });
    }, [lat, lng]);

    return isLoaded ? (
        <>
            <GoogleMap
                mapContainerStyle={containerStyle}
                center={
                    isValidCoord(coordinates?.lat, coordinates?.lng)
                        ? { lat: Number(coordinates.lat), lng: Number(coordinates.lng) }
                        : DEFAULT_CENTER
                }
                zoom={10}
                onLoad={onLoad}
                onUnmount={onUnmount}
                onClick={handleMapClick}
            >
                {/* Child components, such as markers, info windows, etc. */}
                {isValidCoord(marker?.lat, marker?.lng) && (
                    <Marker
                        position={{ lat: Number(marker.lat), lng: Number(marker.lng) }}
                    ></Marker>
                )}
            </GoogleMap>
        </>
    ) : (
        <></>
    );
};

export default React.memo(GoogleMaps);
